import React from 'react'
import ZipDownloaderButton from 'components/shared/ZipDownloaderButton'
import Button from 'components/shared/Button'
import {Dropdown, Menu} from 'antd'
import { DownOutlined } from '@ant-design/icons'

interface Props {
  productId: string
}

const DownloadZipDropdown = ({productId}: Props) => {
  return (
    <Dropdown overlay={
      <Menu>
        <Menu.Item>
          <ZipDownloaderButton productId={productId} size="original" />
        </Menu.Item>
        <Menu.Item>
          <ZipDownloaderButton productId={productId} size="monitor" />
        </Menu.Item>
      </Menu>
    }>
      <Button>
        Last ned .zip <DownOutlined />
      </Button>
    </Dropdown>
  );
}

export default DownloadZipDropdown
